import styled from 'styled-components';

const TimeAgo = styled.span`
  margin-top: 10px;
  margin-left: 10px;
  font-family: var(--main-font-light);
  padding: 5px;
  font-size: 10px ;
  border-radius: 4px;
  background-color: ${({theme:{articleCard}}) => `${articleCard.publish}30`};
`;

export default TimeAgo;


// WEBPACK FOOTER //
// ./src/components/Article/TimeAgo.js